import { CALL_API } from 'middleware/api';
import { GET_STREAKS_FAILURE, GET_STREAKS_REQUEST, GET_STREAKS_SUCCESS, } from './types';
export const getStreaks = (month) => ({
    [CALL_API]: {
        endpoint: `/streaks?month=${month}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        extra: { month },
        types: [GET_STREAKS_REQUEST, GET_STREAKS_SUCCESS, GET_STREAKS_FAILURE],
    },
});
